import React from "react";
import {
  Box,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import { colors } from "../../theme/theme";
import { useNavigate } from "react-router-dom";
import { useHorizontalDragScroll } from "../../utils/useHorizontalDragScroll";

const ProductCards = ({ productData }) => {
  const navigate = useNavigate();
  const ref = useHorizontalDragScroll();

  return (
    <Box
      ref={ref}
      className="flex overflow-x-auto"
      sx={{
        display: "flex",
        gap: 2,
        pb: 2,
        width: "100%",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        cursor: "grab",
        "&:active": {
          cursor: "grabbing",
        },
      }}
    >
      {productData.map((product, index) => (
        <Stack
          key={index}
          direction={"column"}
        >
          <Card
            onClick={() => {
              navigate("/product", {
                state: {
                  product: product,
                },
              });
            }}
            sx={{
              width: "240px",
              height: "440px",
              borderRadius: "12px",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
              flexShrink: 0,
              position: "relative",
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
              border: "1px solid #eee",
              backgroundColor: "#fff",
              overflow: "hidden",
              cursor: "pointer",
              "&:hover": {
                boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                transform: "translateY(-2px)",
              },
            }}
          >
            {product?.price?.sale_percentage != null && (
              <Box
                sx={{
                  position: "absolute",
                  top: "12px",
                  right: "12px",
                  backgroundColor: "#e74c3c",
                  color: "#fff",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  fontSize: "11px",
                  fontFamily: "Poppins-SemiBold",
                  fontWeight: 600,
                  zIndex: 2,
                }}
              >
                -{Math.round(product?.price?.sale_percentage)}%
              </Box>
            )}

            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "280px",
                overflow: "hidden",
                backgroundColor: "#f8f8f8",
              }}
            >
              <img
                src={product?.image_url}
                alt=""
                onError={(e) =>
                  (e.target.src = require("../../assets/images/no_image.png"))
                }
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>

            <CardContent
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                padding: "16px !important",
                backgroundColor: "#fff",
              }}
            >
              {/* Brand Badge */}
              {product?.brand && (
                <Typography
                  sx={{
                    fontSize: "10px",
                    fontFamily: "Poppins-Medium",
                    fontWeight: 500,
                    color: "#999",
                    textTransform: "uppercase",
                    mb: 1,
                  }}
                >
                  {product?.brand}
                </Typography>
              )}

              <Typography
                variant="h6"
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  color: "#1a1a1a",
                  fontFamily: "Poppins-SemiBold",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  lineHeight: 1.4,
                  mb: 0.75,
                }}
              >
                {product?.title}
              </Typography>
              {product?.description && (
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "12px",
                    color: "#666",
                    fontFamily: "Poppins-Regular",
                    lineHeight: 1.5,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    mb: 1.5,
                  }}
                >
                  {product?.description}
                </Typography>
              )}
              <Box sx={{ mt: "auto", pt: 1, borderTop: "1px solid #f0f0f0" }}>
                <Stack direction="row" alignItems="baseline" spacing={1}>
                  {product?.price?.discounted && (
                    <Typography
                      sx={{
                        fontSize: "18px",
                        fontWeight: 700,
                        color: "#1a1a1a",
                        fontFamily: "Poppins-Bold",
                      }}
                    >
                      {product?.price?.discounted}{" "}
                      {product?.price?.currency}
                    </Typography>
                  )}
                  {product?.price?.discounted && (
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#999",
                        fontFamily: "Poppins-Regular",
                        textDecoration: "line-through",
                      }}
                    >
                      {product?.price?.original}
                    </Typography>
                  )}
                  {!product?.price?.discounted && (
                    <Typography
                      sx={{
                        fontSize: "18px",
                        fontWeight: 700,
                        color: "#1a1a1a",
                        fontFamily: "Poppins-Bold",
                      }}
                    >
                      {product?.price?.original || "N/A"}{" "}
                      {product?.price?.currency || ""}
                    </Typography>
                  )}
                </Stack>
              </Box>
            </CardContent>
          </Card>
          {/* <Box
            sx={{
              height: "max-content",
              borderRadius: "15px",
              backgroundColor: "#fff",
              boxShadow: "0px 0px 4px 0px #0000001A",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              mt: 2,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Poppins-SemiBold",
                color: "#000",
                fontSize: "14px",
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
              }}
            >
              {product?.attributes}
            </Typography>
          </Box> */}
        </Stack>
      ))}
    </Box>
  );
};

export default ProductCards;
